<header [class.vehicle-info-layout__header--solo]="logoResolved() && !partnerLogoUrl()">
	@if (!logoResolved()) {
		<div class="vehicle-info-layout__logo-skeleton" aria-busy="true" aria-live="polite"></div>
		<span aria-hidden="true"></span>
	} @else {
		@if (partnerLogoUrl(); as url) {
			<img [src]="url" alt="Operator logo" />
			<span aria-hidden="true"></span>
		}
	}
	<img src="assets/images/CorePark_Logo_White.svg" alt="Corepark" />
</header>
<main class="vehicle-info-layout__container">
	<router-outlet />
</main>
